import { map, of } from 'rxjs'
import { switchMap, withLatestFrom, filter } from 'rxjs/operators'
import Actions from '../actions'
import { catchAndDispatchError, getPayload } from 'utils/rxUtils'
import { deserializePlanByRank } from 'utils/serializerUtil'
import { getParameterFromURL } from 'utils/routingUtils'
import apis from '../apis'

export const getRankingDataEpic = action$ =>
  action$.pipe(
    getPayload(Actions.PLAN_RANKS_REQUESTED),
    switchMap(() => {
      return apis.getRanking().pipe(
        map(rankingData => {
          return Actions.createAction(Actions.PLAN_RANKS_RECEIVED, {
            rankingData
          })
        }),
        catchAndDispatchError
      )
    })
  )

export const getPlansEpic = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.PLANS_REQUESTED),
    withLatestFrom(state$),
    map(([, state]) => [state, getParameterFromURL(state, 'application_id')]),
    switchMap(([state, applicationId]) =>
      apis.getCustomPricePlans(applicationId, state.locale?.locale).pipe(
        map(res => {
          return Actions.createAction(Actions.PLANS_RECEIVED, {
            plans: deserializePlanByRank({
              plans: res,
              rankToSortBy: state.plan?.planRank
            })
          })
        }),
        catchAndDispatchError
      )
    )
  )

export const loadPlans = action$ =>
  action$.pipe(
    getPayload(Actions.APPLICATION_DATA_RECEIVED),
    map(({ data }) => data),
    map(({ plans }) => ({ plans })),
    map(deserializePlanByRank),
    switchMap(plans =>
      of(Actions.createAction(Actions.PLANS_RECEIVED, { plans }))
    )
  )
  
  export const rankReceivedEpic = action$ =>
    action$.pipe(
      getPayload(Actions.APPLICATION_DATA_RECEIVED),
      map(({ data }) => data),
      map(({ rank }) =>
        Actions.createAction(Actions.PLAN_RANK_SELECTED, { planRank: rank })
      )
    )

export const loadSelctedPlans = action$ =>
  action$.pipe(
    getPayload(Actions.APPLICATION_DATA_RECEIVED),
    map(({ data }) => data),
    switchMap(({ plan, plans }) => {
      const selectedPlan = plans?.find(({ id }) => id === plan)
      return of(
        Actions.createAction(Actions.PLAN_SELECTED, { plan: selectedPlan })
      )
    })
  )

export const checkPlanPriceChanged = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.CHECK_IF_PLAN_PRICE_CHANGED),
    withLatestFrom(state$),
    filter(
      ([data, state]) =>
        !!data?.plan_custom_price &&
        data?.plan_custom_price !==
          state?.plan?.selectedPlan?.plan_rate_multiplied
    ),
    map(([data, _]) =>
      Actions.createAction(Actions.PLAN_PRICE_CHANGED, {
        plan_rate_multiplied: data?.plan_custom_price
      })
    )
  )
